import {api} from "@/service/APIClient";
import {ReuseMinCapGroupDTO, ReuseMinCapsDTO} from "@/models/ReuseMinCapsDTO";

const CACHE_TTL_MS = 60000

let cache: {loadedAt: number, promise: Promise<ReuseMinCapsDTO>}|null = null

export const loadReuseMinCaps = (force = false): Promise<ReuseMinCapsDTO> => {
  if (!force && cache !== null && Date.now() - cache.loadedAt < CACHE_TTL_MS) {
    return cache.promise
  }

  const promise = api.reuseMinCaps().then((data) => (Array.isArray(data) ? {} : data) as ReuseMinCapsDTO)
  cache = {loadedAt: Date.now(), promise}
  promise.catch(() => {
    cache = null
  })

  return promise
}

export type ReuseMinCapStatus = 'ok'|'partial'|'blocked'

export interface ReuseMinCapEvaluation {
  status: ReuseMinCapStatus
  partialGroups: ReuseMinCapGroupDTO[]
  blockedGroups: ReuseMinCapGroupDTO[]
}

export const evaluateReuseMinCaps = (
  caps: ReuseMinCapsDTO|null,
  currency: string|null|undefined,
  minPayInDealSum: number|null,
): ReuseMinCapEvaluation => {
  const ok: ReuseMinCapEvaluation = {status: 'ok', partialGroups: [], blockedGroups: []}
  const groups = currency && caps ? (caps[currency] ?? []) : []
  if (groups.length === 0 || minPayInDealSum === null || minPayInDealSum <= 0) {
    return ok
  }

  const partialGroups: ReuseMinCapGroupDTO[] = []
  const blockedGroups: ReuseMinCapGroupDTO[] = []
  for (const group of groups) {
    if (minPayInDealSum <= parseFloat(group.strictCap)) {
      continue
    }

    if (group.looseCap !== null && minPayInDealSum > parseFloat(group.looseCap)) {
      blockedGroups.push(group)
    } else {
      partialGroups.push(group)
    }
  }

  if (partialGroups.length === 0 && blockedGroups.length === 0) {
    return ok
  }

  return {
    status: blockedGroups.length === groups.length ? 'blocked' : 'partial',
    partialGroups,
    blockedGroups,
  }
}
